import React, {Component} from 'react';
import Modal from "../Modal";
import PropTypes from "prop-types";
import UserApi from "../../api/UserApi";
import Icon from "../Icon";

class LostPasswordOverlay extends Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func
  };

  constructor(props) {
    super(props);

    this.state = {
      error: null,
      success: false
    }
  }


  onLostPassword(e) {
    e.preventDefault();

    UserApi.requestPassword(document.getElementById('request-password-mail').value).then(() => {
      this.setState({
        success: true
      });
    }).catch(e => {
      if (e.response.data.error) {
        this.setState({ error: e.response.data.error });
      }
    });

    return false;
  }

  render() {
    const { visible } = this.props;
    const { error, success } = this.state;

    return (
      <Modal visible={visible} onClose={this.props.onClose} header={<h5>Lost Password</h5>}>
        <div className={'user-form'}>
          <form onSubmit={this.onLostPassword.bind(this)}>
            {error && <div className={'error-messages'}>{error}</div>}

            <div className={'form-group'}>
              <label>E-Mail-Address</label>
              <input type={'text'} name={"email"} id={"request-password-mail"} className={'form-control'} />
            </div>

            {success && <div className={'success-message'}>You will recive an E-Mail with instructions to reset your password</div>}

            <button className={'btn btn-primary btn-block icon-right'}>Request new Password <Icon icon={'arrow-right'} /></button>
          </form>
        </div>
      </Modal>
    );
  }
}

export default LostPasswordOverlay;